// Traductions Postinity — Phase B : pages d'accès (garant, cérémonie, message).
const fr = {
  ac_err_invalid: "Ce lien est invalide ou a expiré.",
  ac_err_load: "Erreur de chargement.",
  ac_pay_fail: "Paiement impossible",
  ac_pay_canceled: "Paiement annulé.",
  ac_dl_fail: "Téléchargement impossible",
  ac_video: "Vidéo",
  ac_loading_video: "Chargement de la vidéo…",
  ac_photos_n: "{{count}} photos",
  ac_account_btn: "Créer mon compte / me connecter",
  ac_tribute_to: "En hommage à {{name}}",
  ac_unlock_price_btn: "Débloquer pour {{price}}",
  pl_confirm1: "⚠️ Vous êtes sur le point de CONFIRMER LE DÉCÈS de cette personne.\n\nCe lien vous est strictement personnel. La confirmation ne sera prise en compte que lorsque les TROIS garants auront confirmé. Après contrôle, l'administrateur Postinity enverra les messages enregistrés.\n\nSouhaitez-vous continuer ?",
  pl_confirm2: "Confirmez-vous définitivement le décès ? (2ᵉ confirmation)",
  pl_toast_ok: "Votre confirmation a bien été enregistrée 🕯️",
  pl_toast_fail: "Confirmation impossible",
  pl_secure_link: "Lien sécurisé personne garante",
  pl_intro: "{{name}}vous avez été désigné(e) <span class='text-amber-200 font-medium'>personne garante</span> de cet hommage. Le moment venu, <span class='text-amber-200 font-medium'>les {{n}} garants confirment le décès</span>. Après contrôle, l'administrateur Postinity enverra les messages enregistrés.",
  pl_alert_title: "À lire avant de confirmer",
  pl_alert_1: "<strong>Ce lien est unique et personnel</strong> : il vous est réservé, ne le partagez pas.",
  pl_alert_2: "La confirmation du décès nécessite <strong>obligatoirement l'activation des trois garants</strong>.",
  pl_alert_3: "Après contrôle, l'<strong>administrateur Postinity</strong> enverra les messages enregistrés.",
  pl_alert_4: "✅ La démarche est <strong>entièrement gratuite</strong> et <strong>strictement confidentielle</strong>.",
  pl_status_rest: " / {{total}} garant(s) ont confirmé le décès",
  pl_confirmed_saved: "Votre confirmation est enregistrée.",
  pl_all_confirmed: "Tous les garants ont confirmé — en attente du contrôle de Postinity.",
  pl_waiting_others: "En attente de la confirmation des autres garants.",
  pl_confirm_btn: "Confirmer le décès",
  ca_err_notfound: "Ce dossier de cérémonie est introuvable.",
  ca_unlocked: "Dossier débloqué 🎉",
  ca_badge: "Dossier de Ma Cérémonie",
  ca_songs_title: "Chansons de la cérémonie",
  ca_view_slideshow: "Voir le diaporama",
  ca_close: "Fermer",
  ca_not_available: "Ce dossier n'est pas encore disponible.",
  ca_create_msg: "Créez votre compte gratuit pour accéder au dossier de cérémonie.",
  ca_access_msg: "Accédez à toutes ces informations (photos, vidéo, message) pour {{price}}.",
  ma_unlocked: "Message débloqué 🎉",
  ma_badge: "Message personnel",
  ma_default_title: "Un message pour vous",
  ma_from: "De",
  ma_someone: "un proche",
  ma_for: "pour",
  ma_download_btn: "Télécharger le message",
  ma_read: "lire",
  ma_unlock_word: "débloquer",
  ma_create_msg: "Créez votre compte gratuit pour {{action}} ce message.",
  ma_read_free_btn: "Lire ce message (offert)",
  ma_unlock_msg: "Débloquez ce message personnel pour {{price}}.",
};
const en = {
  ac_err_invalid: "This link is invalid or has expired.",
  ac_err_load: "Loading error.",
  ac_pay_fail: "Payment failed",
  ac_pay_canceled: "Payment canceled.",
  ac_dl_fail: "Download failed",
  ac_video: "Video",
  ac_loading_video: "Loading the video…",
  ac_photos_n: "{{count}} photos",
  ac_account_btn: "Create my account / sign in",
  ac_tribute_to: "In memory of {{name}}",
  ac_unlock_price_btn: "Unlock for {{price}}",
  pl_confirm1: "⚠️ You are about to CONFIRM THE PASSING of this person.\n\nThis link is strictly personal to you. The confirmation is only taken into account once ALL THREE guardians have confirmed. After review, the Postinity administrator will send the recorded messages.\n\nDo you wish to continue?",
  pl_confirm2: "Do you definitively confirm the passing? (2nd confirmation)",
  pl_toast_ok: "Your confirmation has been recorded 🕯️",
  pl_toast_fail: "Confirmation failed",
  pl_secure_link: "Secure guardian link",
  pl_intro: "{{name}}you have been designated a <span class='text-amber-200 font-medium'>guardian</span> of this tribute. When the time comes, <span class='text-amber-200 font-medium'>the {{n}} guardians confirm the passing</span>. After review, the Postinity administrator will send the recorded messages.",
  pl_alert_title: "Please read before confirming",
  pl_alert_1: "<strong>This link is unique and personal</strong>: it is reserved for you, do not share it.",
  pl_alert_2: "Confirming the passing <strong>requires all three guardians to be activated</strong>.",
  pl_alert_3: "After review, the <strong>Postinity administrator</strong> will send the recorded messages.",
  pl_alert_4: "✅ The process is <strong>entirely free</strong> and <strong>strictly confidential</strong>.",
  pl_status_rest: " / {{total}} guardian(s) have confirmed the passing",
  pl_confirmed_saved: "Your confirmation is recorded.",
  pl_all_confirmed: "All guardians have confirmed — awaiting Postinity's review.",
  pl_waiting_others: "Awaiting confirmation from the other guardians.",
  pl_confirm_btn: "Confirm the passing",
  ca_err_notfound: "This ceremony file cannot be found.",
  ca_unlocked: "File unlocked 🎉",
  ca_badge: "My Ceremony File",
  ca_songs_title: "Ceremony songs",
  ca_view_slideshow: "View the slideshow",
  ca_close: "Close",
  ca_not_available: "This file is not available yet.",
  ca_create_msg: "Create your free account to access the ceremony file.",
  ca_access_msg: "Access all this content (photos, video, message) for {{price}}.",
  ma_unlocked: "Message unlocked 🎉",
  ma_badge: "Personal message",
  ma_default_title: "A message for you",
  ma_from: "From",
  ma_someone: "a loved one",
  ma_for: "for",
  ma_download_btn: "Download the message",
  ma_read: "read",
  ma_unlock_word: "unlock",
  ma_create_msg: "Create your free account to {{action}} this message.",
  ma_read_free_btn: "Read this message (free)",
  ma_unlock_msg: "Unlock this personal message for {{price}}.",
};
const es = {
  ac_err_invalid: "Este enlace no es válido o ha caducado.",
  ac_err_load: "Error de carga.",
  ac_pay_fail: "No se pudo procesar el pago",
  ac_pay_canceled: "Pago cancelado.",
  ac_dl_fail: "No se pudo descargar",
  ac_video: "Video",
  ac_loading_video: "Cargando el video…",
  ac_photos_n: "{{count}} fotos",
  ac_account_btn: "Crear mi cuenta / iniciar sesión",
  ac_tribute_to: "En memoria de {{name}}",
  ac_unlock_price_btn: "Desbloquear por {{price}}",
  pl_confirm1: "⚠️ Está a punto de CONFIRMAR EL FALLECIMIENTO de esta persona.\n\nEste enlace es estrictamente personal. La confirmación solo se tendrá en cuenta cuando los TRES garantes hayan confirmado. Tras la revisión, el administrador de Postinity enviará los mensajes registrados.\n\n¿Desea continuar?",
  pl_confirm2: "¿Confirma definitivamente el fallecimiento? (2ª confirmación)",
  pl_toast_ok: "Su confirmación ha sido registrada 🕯️",
  pl_toast_fail: "No se pudo confirmar",
  pl_secure_link: "Enlace seguro de garante",
  pl_intro: "{{name}}usted ha sido designado(a) <span class='text-amber-200 font-medium'>garante</span> de este homenaje. Llegado el momento, <span class='text-amber-200 font-medium'>los {{n}} garantes confirman el fallecimiento</span>. Tras la revisión, el administrador de Postinity enviará los mensajes registrados.",
  pl_alert_title: "Lea antes de confirmar",
  pl_alert_1: "<strong>Este enlace es único y personal</strong>: está reservado para usted, no lo comparta.",
  pl_alert_2: "La confirmación del fallecimiento <strong>requiere obligatoriamente la activación de los tres garantes</strong>.",
  pl_alert_3: "Tras la revisión, el <strong>administrador de Postinity</strong> enviará los mensajes registrados.",
  pl_alert_4: "✅ El proceso es <strong>totalmente gratuito</strong> y <strong>estrictamente confidencial</strong>.",
  pl_status_rest: " / {{total}} garante(s) han confirmado el fallecimiento",
  pl_confirmed_saved: "Su confirmación está registrada.",
  pl_all_confirmed: "Todos los garantes han confirmado — a la espera de la revisión de Postinity.",
  pl_waiting_others: "A la espera de la confirmación de los demás garantes.",
  pl_confirm_btn: "Confirmar el fallecimiento",
  ca_err_notfound: "No se encuentra este expediente de ceremonia.",
  ca_unlocked: "Expediente desbloqueado 🎉",
  ca_badge: "Expediente de Mi Ceremonia",
  ca_songs_title: "Canciones de la ceremonia",
  ca_view_slideshow: "Ver la presentación",
  ca_close: "Cerrar",
  ca_not_available: "Este expediente aún no está disponible.",
  ca_create_msg: "Cree su cuenta gratuita para acceder al expediente de la ceremonia.",
  ca_access_msg: "Acceda a toda esta información (fotos, video, mensaje) por {{price}}.",
  ma_unlocked: "Mensaje desbloqueado 🎉",
  ma_badge: "Mensaje personal",
  ma_default_title: "Un mensaje para ti",
  ma_from: "De",
  ma_someone: "un ser querido",
  ma_for: "para",
  ma_download_btn: "Descargar el mensaje",
  ma_read: "leer",
  ma_unlock_word: "desbloquear",
  ma_create_msg: "Cree su cuenta gratuita para {{action}} este mensaje.",
  ma_read_free_btn: "Leer este mensaje (gratis)",
  ma_unlock_msg: "Desbloquee este mensaje personal por {{price}}.",
};
const de = {
  ac_err_invalid: "Dieser Link ist ungültig oder abgelaufen.",
  ac_err_load: "Ladefehler.",
  ac_pay_fail: "Zahlung fehlgeschlagen",
  ac_pay_canceled: "Zahlung abgebrochen.",
  ac_dl_fail: "Download fehlgeschlagen",
  ac_video: "Video",
  ac_loading_video: "Video wird geladen…",
  ac_photos_n: "{{count}} Fotos",
  ac_account_btn: "Konto erstellen / anmelden",
  ac_tribute_to: "Zum Gedenken an {{name}}",
  ac_unlock_price_btn: "Freischalten für {{price}}",
  pl_confirm1: "⚠️ Sie sind dabei, den TOD dieser Person zu BESTÄTIGEN.\n\nDieser Link ist streng persönlich. Die Bestätigung wird erst berücksichtigt, wenn ALLE DREI Bürgen bestätigt haben. Nach der Prüfung sendet der Postinity-Administrator die hinterlegten Nachrichten.\n\nMöchten Sie fortfahren?",
  pl_confirm2: "Bestätigen Sie den Tod endgültig? (2. Bestätigung)",
  pl_toast_ok: "Ihre Bestätigung wurde gespeichert 🕯️",
  pl_toast_fail: "Bestätigung fehlgeschlagen",
  pl_secure_link: "Sicherer Bürgen-Link",
  pl_intro: "{{name}}Sie wurden als <span class='text-amber-200 font-medium'>Bürge</span> dieser Gedenkseite benannt. Wenn es so weit ist, <span class='text-amber-200 font-medium'>bestätigen die {{n}} Bürgen den Tod</span>. Nach der Prüfung sendet der Postinity-Administrator die hinterlegten Nachrichten.",
  pl_alert_title: "Bitte vor dem Bestätigen lesen",
  pl_alert_1: "<strong>Dieser Link ist einzigartig und persönlich</strong>: Er ist Ihnen vorbehalten, teilen Sie ihn nicht.",
  pl_alert_2: "Die Bestätigung des Todes <strong>erfordert zwingend die Aktivierung der drei Bürgen</strong>.",
  pl_alert_3: "Nach der Prüfung sendet der <strong>Postinity-Administrator</strong> die hinterlegten Nachrichten.",
  pl_alert_4: "✅ Der Vorgang ist <strong>völlig kostenlos</strong> und <strong>streng vertraulich</strong>.",
  pl_status_rest: " / {{total}} Bürge(n) haben den Tod bestätigt",
  pl_confirmed_saved: "Ihre Bestätigung ist gespeichert.",
  pl_all_confirmed: "Alle Bürgen haben bestätigt — Prüfung durch Postinity ausstehend.",
  pl_waiting_others: "Warten auf die Bestätigung der anderen Bürgen.",
  pl_confirm_btn: "Tod bestätigen",
  ca_err_notfound: "Diese Zeremonie-Akte wurde nicht gefunden.",
  ca_unlocked: "Akte freigeschaltet 🎉",
  ca_badge: "Akte meiner Zeremonie",
  ca_songs_title: "Lieder der Zeremonie",
  ca_view_slideshow: "Diashow ansehen",
  ca_close: "Schließen",
  ca_not_available: "Diese Akte ist noch nicht verfügbar.",
  ca_create_msg: "Erstellen Sie Ihr kostenloses Konto, um auf die Zeremonie-Akte zuzugreifen.",
  ca_access_msg: "Greifen Sie auf all diese Inhalte (Fotos, Video, Nachricht) für {{price}} zu.",
  ma_unlocked: "Nachricht freigeschaltet 🎉",
  ma_badge: "Persönliche Nachricht",
  ma_default_title: "Eine Nachricht für dich",
  ma_from: "Von",
  ma_someone: "einer nahestehenden Person",
  ma_for: "für",
  ma_download_btn: "Nachricht herunterladen",
  ma_read: "lesen",
  ma_unlock_word: "freischalten",
  ma_create_msg: "Erstellen Sie Ihr kostenloses Konto, um diese Nachricht zu {{action}}.",
  ma_read_free_btn: "Diese Nachricht lesen (gratis)",
  ma_unlock_msg: "Schalten Sie diese persönliche Nachricht für {{price}} frei.",
};
const it = {
  ac_err_invalid: "Questo link non è valido o è scaduto.",
  ac_err_load: "Errore di caricamento.",
  ac_pay_fail: "Pagamento non riuscito",
  ac_pay_canceled: "Pagamento annullato.",
  ac_dl_fail: "Download non riuscito",
  ac_video: "Video",
  ac_loading_video: "Caricamento del video…",
  ac_photos_n: "{{count}} foto",
  ac_account_btn: "Crea il mio account / accedi",
  ac_tribute_to: "In memoria di {{name}}",
  ac_unlock_price_btn: "Sblocca per {{price}}",
  pl_confirm1: "⚠️ Stai per CONFERMARE IL DECESSO di questa persona.\n\nQuesto link è strettamente personale. La conferma sarà presa in considerazione solo quando TUTTI E TRE i garanti avranno confermato. Dopo il controllo, l'amministratore Postinity invierà i messaggi registrati.\n\nVuoi continuare?",
  pl_confirm2: "Confermi definitivamente il decesso? (2ª conferma)",
  pl_toast_ok: "La tua conferma è stata registrata 🕯️",
  pl_toast_fail: "Conferma non riuscita",
  pl_secure_link: "Link sicuro del garante",
  pl_intro: "{{name}}sei stato/a designato/a <span class='text-amber-200 font-medium'>garante</span> di questo omaggio. Al momento opportuno, <span class='text-amber-200 font-medium'>i {{n}} garanti confermano il decesso</span>. Dopo il controllo, l'amministratore Postinity invierà i messaggi registrati.",
  pl_alert_title: "Da leggere prima di confermare",
  pl_alert_1: "<strong>Questo link è unico e personale</strong>: è riservato a te, non condividerlo.",
  pl_alert_2: "La conferma del decesso <strong>richiede obbligatoriamente l'attivazione dei tre garanti</strong>.",
  pl_alert_3: "Dopo il controllo, l'<strong>amministratore Postinity</strong> invierà i messaggi registrati.",
  pl_alert_4: "✅ La procedura è <strong>completamente gratuita</strong> e <strong>strettamente riservata</strong>.",
  pl_status_rest: " / {{total}} garante/i hanno confermato il decesso",
  pl_confirmed_saved: "La tua conferma è registrata.",
  pl_all_confirmed: "Tutti i garanti hanno confermato — in attesa del controllo di Postinity.",
  pl_waiting_others: "In attesa della conferma degli altri garanti.",
  pl_confirm_btn: "Conferma il decesso",
  ca_err_notfound: "Questo dossier della cerimonia non è stato trovato.",
  ca_unlocked: "Dossier sbloccato 🎉",
  ca_badge: "Dossier della Mia Cerimonia",
  ca_songs_title: "Canzoni della cerimonia",
  ca_view_slideshow: "Guarda la presentazione",
  ca_close: "Chiudi",
  ca_not_available: "Questo dossier non è ancora disponibile.",
  ca_create_msg: "Crea il tuo account gratuito per accedere al dossier della cerimonia.",
  ca_access_msg: "Accedi a tutti questi contenuti (foto, video, messaggio) per {{price}}.",
  ma_unlocked: "Messaggio sbloccato 🎉",
  ma_badge: "Messaggio personale",
  ma_default_title: "Un messaggio per te",
  ma_from: "Da",
  ma_someone: "una persona cara",
  ma_for: "per",
  ma_download_btn: "Scarica il messaggio",
  ma_read: "leggere",
  ma_unlock_word: "sbloccare",
  ma_create_msg: "Crea il tuo account gratuito per {{action}} questo messaggio.",
  ma_read_free_btn: "Leggi questo messaggio (gratis)",
  ma_unlock_msg: "Sblocca questo messaggio personale per {{price}}.",
};
const pl = {
  ac_err_invalid: "Ten link jest nieprawidłowy lub wygasł.",
  ac_err_load: "Błąd ładowania.",
  ac_pay_fail: "Płatność nie powiodła się",
  ac_pay_canceled: "Płatność anulowana.",
  ac_dl_fail: "Pobieranie nie powiodło się",
  ac_video: "Wideo",
  ac_loading_video: "Ładowanie wideo…",
  ac_photos_n: "{{count}} zdjęć",
  ac_account_btn: "Załóż konto / zaloguj się",
  ac_tribute_to: "Ku pamięci {{name}}",
  ac_unlock_price_btn: "Odblokuj za {{price}}",
  pl_confirm1: "⚠️ Zamierzasz POTWIERDZIĆ ŚMIERĆ tej osoby.\n\nTen link jest ściśle osobisty. Potwierdzenie zostanie uwzględnione dopiero, gdy WSZYSCY TRZEJ poręczyciele potwierdzą. Po weryfikacji administrator Postinity wyśle zapisane wiadomości.\n\nCzy chcesz kontynuować?",
  pl_confirm2: "Czy ostatecznie potwierdzasz śmierć? (2. potwierdzenie)",
  pl_toast_ok: "Twoje potwierdzenie zostało zapisane 🕯️",
  pl_toast_fail: "Potwierdzenie nie powiodło się",
  pl_secure_link: "Bezpieczny link poręczyciela",
  pl_intro: "{{name}}zostałeś(-aś) wyznaczony(-a) na <span class='text-amber-200 font-medium'>poręczyciela</span> tego hołdu. Gdy nadejdzie czas, <span class='text-amber-200 font-medium'>{{n}} poręczycieli potwierdza śmierć</span>. Po weryfikacji administrator Postinity wyśle zapisane wiadomości.",
  pl_alert_title: "Przeczytaj przed potwierdzeniem",
  pl_alert_1: "<strong>Ten link jest unikalny i osobisty</strong>: jest zarezerwowany dla Ciebie, nie udostępniaj go.",
  pl_alert_2: "Potwierdzenie śmierci <strong>wymaga obowiązkowo aktywacji trzech poręczycieli</strong>.",
  pl_alert_3: "Po weryfikacji <strong>administrator Postinity</strong> wyśle zapisane wiadomości.",
  pl_alert_4: "✅ Procedura jest <strong>całkowicie bezpłatna</strong> i <strong>ściśle poufna</strong>.",
  pl_status_rest: " / {{total}} poręczyciel(i) potwierdziło śmierć",
  pl_confirmed_saved: "Twoje potwierdzenie zostało zapisane.",
  pl_all_confirmed: "Wszyscy poręczyciele potwierdzili — oczekiwanie na weryfikację Postinity.",
  pl_waiting_others: "Oczekiwanie na potwierdzenie pozostałych poręczycieli.",
  pl_confirm_btn: "Potwierdź śmierć",
  ca_err_notfound: "Nie znaleziono tego dossier ceremonii.",
  ca_unlocked: "Dossier odblokowane 🎉",
  ca_badge: "Dossier Mojej Ceremonii",
  ca_songs_title: "Piosenki ceremonii",
  ca_view_slideshow: "Zobacz pokaz slajdów",
  ca_close: "Zamknij",
  ca_not_available: "To dossier nie jest jeszcze dostępne.",
  ca_create_msg: "Załóż darmowe konto, aby uzyskać dostęp do dossier ceremonii.",
  ca_access_msg: "Uzyskaj dostęp do wszystkich treści (zdjęcia, wideo, wiadomość) za {{price}}.",
  ma_unlocked: "Wiadomość odblokowana 🎉",
  ma_badge: "Wiadomość osobista",
  ma_default_title: "Wiadomość dla Ciebie",
  ma_from: "Od",
  ma_someone: "bliskiej osoby",
  ma_for: "dla",
  ma_download_btn: "Pobierz wiadomość",
  ma_read: "przeczytać",
  ma_unlock_word: "odblokować",
  ma_create_msg: "Załóż darmowe konto, aby {{action}} tę wiadomość.",
  ma_read_free_btn: "Przeczytaj tę wiadomość (za darmo)",
  ma_unlock_msg: "Odblokuj tę osobistą wiadomość za {{price}}.",
};
const fil = {
  ac_err_invalid: "Hindi wasto o nag-expire na ang link na ito.",
  ac_err_load: "Error sa pag-load.",
  ac_pay_fail: "Nabigo ang pagbabayad",
  ac_pay_canceled: "Kanselado ang pagbabayad.",
  ac_dl_fail: "Nabigo ang pag-download",
  ac_video: "Video",
  ac_loading_video: "Nilo-load ang video…",
  ac_photos_n: "{{count}} larawan",
  ac_account_btn: "Gumawa ng account / mag-sign in",
  ac_tribute_to: "Bilang alaala kay {{name}}",
  ac_unlock_price_btn: "I-unlock sa {{price}}",
  pl_confirm1: "⚠️ Malapit mo nang KUMPIRMAHIN ANG PAGKAMATAY ng taong ito.\n\nEksklusibo sa iyo ang link na ito. Isasaalang-alang lamang ang kumpirmasyon kapag nakumpirma na ng LAHAT NG TATLONG garante. Pagkatapos ng pagsusuri, ipapadala ng administrator ng Postinity ang mga naitalang mensahe.\n\nGusto mo bang magpatuloy?",
  pl_confirm2: "Kinukumpirma mo ba nang tuluyan ang pagkamatay? (ika-2 kumpirmasyon)",
  pl_toast_ok: "Naitala na ang iyong kumpirmasyon 🕯️",
  pl_toast_fail: "Nabigo ang kumpirmasyon",
  pl_secure_link: "Secure na link ng garante",
  pl_intro: "{{name}}itinalaga ka bilang <span class='text-amber-200 font-medium'>garante</span> ng parangal na ito. Sa tamang panahon, <span class='text-amber-200 font-medium'>ang {{n}} garante ay kinukumpirma ang pagkamatay</span>. Pagkatapos ng pagsusuri, ipapadala ng administrator ng Postinity ang mga naitalang mensahe.",
  pl_alert_title: "Basahin bago kumpirmahin",
  pl_alert_1: "<strong>Natatangi at personal ang link na ito</strong>: nakalaan ito para sa iyo, huwag itong ibahagi.",
  pl_alert_2: "Ang pagkumpirma ng pagkamatay ay <strong>nangangailangan ng aktibasyon ng tatlong garante</strong>.",
  pl_alert_3: "Pagkatapos ng pagsusuri, ipapadala ng <strong>administrator ng Postinity</strong> ang mga naitalang mensahe.",
  pl_alert_4: "✅ Ang proseso ay <strong>ganap na libre</strong> at <strong>mahigpit na kumpidensyal</strong>.",
  pl_status_rest: " / {{total}} garante ang nagkumpirma ng pagkamatay",
  pl_confirmed_saved: "Naitala ang iyong kumpirmasyon.",
  pl_all_confirmed: "Nakumpirma na ng lahat ng garante — naghihintay ng pagsusuri ng Postinity.",
  pl_waiting_others: "Naghihintay ng kumpirmasyon mula sa ibang garante.",
  pl_confirm_btn: "Kumpirmahin ang pagkamatay",
  ca_err_notfound: "Hindi mahanap ang file ng seremonyang ito.",
  ca_unlocked: "Na-unlock ang file 🎉",
  ca_badge: "File ng Aking Seremonya",
  ca_songs_title: "Mga kanta ng seremonya",
  ca_view_slideshow: "Tingnan ang slideshow",
  ca_close: "Isara",
  ca_not_available: "Hindi pa available ang file na ito.",
  ca_create_msg: "Gumawa ng libreng account para ma-access ang file ng seremonya.",
  ca_access_msg: "I-access ang lahat ng nilalaman (larawan, video, mensahe) sa {{price}}.",
  ma_unlocked: "Na-unlock ang mensahe 🎉",
  ma_badge: "Personal na mensahe",
  ma_default_title: "Isang mensahe para sa iyo",
  ma_from: "Mula kay",
  ma_someone: "isang mahal sa buhay",
  ma_for: "para kay",
  ma_download_btn: "I-download ang mensahe",
  ma_read: "basahin",
  ma_unlock_word: "i-unlock",
  ma_create_msg: "Gumawa ng libreng account para {{action}} ang mensaheng ito.",
  ma_read_free_btn: "Basahin ang mensaheng ito (libre)",
  ma_unlock_msg: "I-unlock ang personal na mensaheng ito sa {{price}}.",
};
const ru = {
  ac_err_invalid: "Эта ссылка недействительна или срок её действия истёк.",
  ac_err_load: "Ошибка загрузки.",
  ac_pay_fail: "Оплата не прошла",
  ac_pay_canceled: "Оплата отменена.",
  ac_dl_fail: "Не удалось скачать",
  ac_video: "Видео",
  ac_loading_video: "Загрузка видео…",
  ac_photos_n: "{{count}} фото",
  ac_account_btn: "Создать аккаунт / войти",
  ac_tribute_to: "В память о {{name}}",
  ac_unlock_price_btn: "Разблокировать за {{price}}",
  pl_confirm1: "⚠️ Вы собираетесь ПОДТВЕРДИТЬ СМЕРТЬ этого человека.\n\nЭта ссылка строго персональна. Подтверждение будет учтено только когда подтвердят ВСЕ ТРОЕ поручителей. После проверки администратор Postinity отправит записанные сообщения.\n\nПродолжить?",
  pl_confirm2: "Вы окончательно подтверждаете смерть? (2-е подтверждение)",
  pl_toast_ok: "Ваше подтверждение записано 🕯️",
  pl_toast_fail: "Не удалось подтвердить",
  pl_secure_link: "Защищённая ссылка поручителя",
  pl_intro: "{{name}}вы были назначены <span class='text-amber-200 font-medium'>поручителем</span> этого мемориала. Когда придёт время, <span class='text-amber-200 font-medium'>{{n}} поручителей подтверждают смерть</span>. После проверки администратор Postinity отправит записанные сообщения.",
  pl_alert_title: "Прочтите перед подтверждением",
  pl_alert_1: "<strong>Эта ссылка уникальна и персональна</strong>: она предназначена только для вас, не передавайте её.",
  pl_alert_2: "Подтверждение смерти <strong>обязательно требует активации трёх поручителей</strong>.",
  pl_alert_3: "После проверки <strong>администратор Postinity</strong> отправит записанные сообщения.",
  pl_alert_4: "✅ Процедура <strong>полностью бесплатна</strong> и <strong>строго конфиденциальна</strong>.",
  pl_status_rest: " / {{total}} поручител(ь/я) подтвердили смерть",
  pl_confirmed_saved: "Ваше подтверждение записано.",
  pl_all_confirmed: "Все поручители подтвердили — ожидается проверка Postinity.",
  pl_waiting_others: "Ожидание подтверждения от других поручителей.",
  pl_confirm_btn: "Подтвердить смерть",
  ca_err_notfound: "Это дело церемонии не найдено.",
  ca_unlocked: "Дело разблокировано 🎉",
  ca_badge: "Дело моей церемонии",
  ca_songs_title: "Песни церемонии",
  ca_view_slideshow: "Смотреть слайд-шоу",
  ca_close: "Закрыть",
  ca_not_available: "Это дело пока недоступно.",
  ca_create_msg: "Создайте бесплатный аккаунт, чтобы получить доступ к делу церемонии.",
  ca_access_msg: "Получите доступ ко всему содержимому (фото, видео, сообщение) за {{price}}.",
  ma_unlocked: "Сообщение разблокировано 🎉",
  ma_badge: "Личное сообщение",
  ma_default_title: "Сообщение для вас",
  ma_from: "От",
  ma_someone: "близкого человека",
  ma_for: "для",
  ma_download_btn: "Скачать сообщение",
  ma_read: "прочитать",
  ma_unlock_word: "разблокировать",
  ma_create_msg: "Создайте бесплатный аккаунт, чтобы {{action}} это сообщение.",
  ma_read_free_btn: "Прочитать это сообщение (бесплатно)",
  ma_unlock_msg: "Разблокируйте это личное сообщение за {{price}}.",
};
const el = {
  ac_err_invalid: "Αυτός ο σύνδεσμος δεν είναι έγκυρος ή έχει λήξει.",
  ac_err_load: "Σφάλμα φόρτωσης.",
  ac_pay_fail: "Η πληρωμή απέτυχε",
  ac_pay_canceled: "Η πληρωμή ακυρώθηκε.",
  ac_dl_fail: "Η λήψη απέτυχε",
  ac_video: "Βίντεο",
  ac_loading_video: "Φόρτωση του βίντεο…",
  ac_photos_n: "{{count}} φωτογραφίες",
  ac_account_btn: "Δημιουργία λογαριασμού / σύνδεση",
  ac_tribute_to: "Στη μνήμη του/της {{name}}",
  ac_unlock_price_btn: "Ξεκλείδωμα για {{price}}",
  pl_confirm1: "⚠️ Πρόκειται να ΕΠΙΒΕΒΑΙΩΣΕΤΕ ΤΟΝ ΘΑΝΑΤΟ αυτού του ατόμου.\n\nΑυτός ο σύνδεσμος είναι αυστηρά προσωπικός. Η επιβεβαίωση θα ληφθεί υπόψη μόνο όταν επιβεβαιώσουν και οι ΤΡΕΙΣ εγγυητές. Μετά τον έλεγχο, ο διαχειριστής της Postinity θα στείλει τα καταχωρημένα μηνύματα.\n\nΘέλετε να συνεχίσετε;",
  pl_confirm2: "Επιβεβαιώνετε οριστικά τον θάνατο; (2η επιβεβαίωση)",
  pl_toast_ok: "Η επιβεβαίωσή σας καταχωρήθηκε 🕯️",
  pl_toast_fail: "Η επιβεβαίωση απέτυχε",
  pl_secure_link: "Ασφαλής σύνδεσμος εγγυητή",
  pl_intro: "{{name}}έχετε οριστεί <span class='text-amber-200 font-medium'>εγγυητής</span> αυτού του αφιερώματος. Όταν έρθει η ώρα, <span class='text-amber-200 font-medium'>οι {{n}} εγγυητές επιβεβαιώνουν τον θάνατο</span>. Μετά τον έλεγχο, ο διαχειριστής της Postinity θα στείλει τα καταχωρημένα μηνύματα.",
  pl_alert_title: "Διαβάστε πριν επιβεβαιώσετε",
  pl_alert_1: "<strong>Αυτός ο σύνδεσμος είναι μοναδικός και προσωπικός</strong>: προορίζεται για εσάς, μην τον μοιράζεστε.",
  pl_alert_2: "Η επιβεβαίωση του θανάτου <strong>απαιτεί υποχρεωτικά την ενεργοποίηση των τριών εγγυητών</strong>.",
  pl_alert_3: "Μετά τον έλεγχο, ο <strong>διαχειριστής της Postinity</strong> θα στείλει τα καταχωρημένα μηνύματα.",
  pl_alert_4: "✅ Η διαδικασία είναι <strong>εντελώς δωρεάν</strong> και <strong>αυστηρά εμπιστευτική</strong>.",
  pl_status_rest: " / {{total}} εγγυητ(ής/ές) επιβεβαίωσαν τον θάνατο",
  pl_confirmed_saved: "Η επιβεβαίωσή σας έχει καταχωρηθεί.",
  pl_all_confirmed: "Όλοι οι εγγυητές επιβεβαίωσαν — αναμονή ελέγχου από την Postinity.",
  pl_waiting_others: "Αναμονή επιβεβαίωσης από τους άλλους εγγυητές.",
  pl_confirm_btn: "Επιβεβαίωση θανάτου",
  ca_err_notfound: "Αυτός ο φάκελος τελετής δεν βρέθηκε.",
  ca_unlocked: "Ο φάκελος ξεκλειδώθηκε 🎉",
  ca_badge: "Φάκελος της Τελετής μου",
  ca_songs_title: "Τραγούδια της τελετής",
  ca_view_slideshow: "Δείτε την παρουσίαση",
  ca_close: "Κλείσιμο",
  ca_not_available: "Αυτός ο φάκελος δεν είναι ακόμη διαθέσιμος.",
  ca_create_msg: "Δημιουργήστε δωρεάν λογαριασμό για πρόσβαση στον φάκελο της τελετής.",
  ca_access_msg: "Αποκτήστε πρόσβαση σε όλο το περιεχόμενο (φωτογραφίες, βίντεο, μήνυμα) για {{price}}.",
  ma_unlocked: "Το μήνυμα ξεκλειδώθηκε 🎉",
  ma_badge: "Προσωπικό μήνυμα",
  ma_default_title: "Ένα μήνυμα για εσάς",
  ma_from: "Από",
  ma_someone: "ένα αγαπημένο πρόσωπο",
  ma_for: "για",
  ma_download_btn: "Λήψη του μηνύματος",
  ma_read: "διαβάσετε",
  ma_unlock_word: "ξεκλειδώσετε",
  ma_create_msg: "Δημιουργήστε δωρεάν λογαριασμό για να {{action}} αυτό το μήνυμα.",
  ma_read_free_btn: "Διαβάστε αυτό το μήνυμα (δωρεάν)",
  ma_unlock_msg: "Ξεκλειδώστε αυτό το προσωπικό μήνυμα για {{price}}.",
};
const hi = {
  ac_err_invalid: "यह लिंक अमान्य है या समाप्त हो चुका है।",
  ac_err_load: "लोड करने में त्रुटि।",
  ac_pay_fail: "भुगतान विफल",
  ac_pay_canceled: "भुगतान रद्द किया गया।",
  ac_dl_fail: "डाउनलोड विफल",
  ac_video: "वीडियो",
  ac_loading_video: "वीडियो लोड हो रहा है…",
  ac_photos_n: "{{count}} फ़ोटो",
  ac_account_btn: "मेरा खाता बनाएँ / साइन इन करें",
  ac_tribute_to: "{{name}} की स्मृति में",
  ac_unlock_price_btn: "{{price}} में अनलॉक करें",
  pl_confirm1: "⚠️ आप इस व्यक्ति की मृत्यु की पुष्टि करने वाले हैं।\n\nयह लिंक पूरी तरह से व्यक्तिगत है। पुष्टि तभी मानी जाएगी जब तीनों गारंटर पुष्टि कर देंगे। जाँच के बाद, Postinity प्रशासक दर्ज संदेश भेजेगा।\n\nक्या आप जारी रखना चाहते हैं?",
  pl_confirm2: "क्या आप मृत्यु की अंतिम पुष्टि करते हैं? (दूसरी पुष्टि)",
  pl_toast_ok: "आपकी पुष्टि दर्ज कर ली गई है 🕯️",
  pl_toast_fail: "पुष्टि विफल",
  pl_secure_link: "सुरक्षित गारंटर लिंक",
  pl_intro: "{{name}}आपको इस श्रद्धांजलि का <span class='text-amber-200 font-medium'>गारंटर</span> नियुक्त किया गया है। समय आने पर, <span class='text-amber-200 font-medium'>{{n}} गारंटर मृत्यु की पुष्टि करते हैं</span>। जाँच के बाद, Postinity प्रशासक दर्ज संदेश भेजेगा।",
  pl_alert_title: "पुष्टि करने से पहले पढ़ें",
  pl_alert_1: "<strong>यह लिंक अद्वितीय और व्यक्तिगत है</strong>: यह केवल आपके लिए है, इसे साझा न करें।",
  pl_alert_2: "मृत्यु की पुष्टि के लिए <strong>तीनों गारंटरों का सक्रिय होना अनिवार्य है</strong>।",
  pl_alert_3: "जाँच के बाद, <strong>Postinity प्रशासक</strong> दर्ज संदेश भेजेगा।",
  pl_alert_4: "✅ यह प्रक्रिया <strong>पूरी तरह निःशुल्क</strong> और <strong>पूर्णतः गोपनीय</strong> है।",
  pl_status_rest: " / {{total}} गारंटर ने मृत्यु की पुष्टि की",
  pl_confirmed_saved: "आपकी पुष्टि दर्ज है।",
  pl_all_confirmed: "सभी गारंटरों ने पुष्टि कर दी — Postinity की जाँच की प्रतीक्षा।",
  pl_waiting_others: "अन्य गारंटरों की पुष्टि की प्रतीक्षा।",
  pl_confirm_btn: "मृत्यु की पुष्टि करें",
  ca_err_notfound: "यह समारोह फ़ाइल नहीं मिली।",
  ca_unlocked: "फ़ाइल अनलॉक हो गई 🎉",
  ca_badge: "मेरे समारोह की फ़ाइल",
  ca_songs_title: "समारोह के गीत",
  ca_view_slideshow: "स्लाइडशो देखें",
  ca_close: "बंद करें",
  ca_not_available: "यह फ़ाइल अभी उपलब्ध नहीं है।",
  ca_create_msg: "समारोह फ़ाइल तक पहुँचने के लिए अपना निःशुल्क खाता बनाएँ।",
  ca_access_msg: "इस सारी सामग्री (फ़ोटो, वीडियो, संदेश) तक {{price}} में पहुँचें।",
  ma_unlocked: "संदेश अनलॉक हो गया 🎉",
  ma_badge: "व्यक्तिगत संदेश",
  ma_default_title: "आपके लिए एक संदेश",
  ma_from: "से",
  ma_someone: "एक प्रियजन",
  ma_for: "के लिए",
  ma_download_btn: "संदेश डाउनलोड करें",
  ma_read: "पढ़ने",
  ma_unlock_word: "अनलॉक करने",
  ma_create_msg: "इस संदेश को {{action}} के लिए अपना निःशुल्क खाता बनाएँ।",
  ma_read_free_btn: "यह संदेश पढ़ें (निःशुल्क)",
  ma_unlock_msg: "इस व्यक्तिगत संदेश को {{price}} में अनलॉक करें।",
};
const ja = {
  ac_err_invalid: "このリンクは無効か、有効期限が切れています。",
  ac_err_load: "読み込みエラー。",
  ac_pay_fail: "支払いに失敗しました",
  ac_pay_canceled: "支払いがキャンセルされました。",
  ac_dl_fail: "ダウンロードに失敗しました",
  ac_video: "動画",
  ac_loading_video: "動画を読み込んでいます…",
  ac_photos_n: "写真 {{count}} 枚",
  ac_account_btn: "アカウントを作成 / ログイン",
  ac_tribute_to: "{{name}} を偲んで",
  ac_unlock_price_btn: "{{price}} でロック解除",
  pl_confirm1: "⚠️ この方の逝去を確認しようとしています。\n\nこのリンクはあなた専用です。確認は3人の保証人全員が確認して初めて有効になります。確認後、Postinity 管理者が登録されたメッセージを送信します。\n\n続行しますか？",
  pl_confirm2: "逝去を最終的に確認しますか？（2回目の確認）",
  pl_toast_ok: "確認が記録されました 🕯️",
  pl_toast_fail: "確認に失敗しました",
  pl_secure_link: "保証人用の安全なリンク",
  pl_intro: "{{name}}あなたはこの追悼の<span class='text-amber-200 font-medium'>保証人</span>に指名されました。その時が来たら、<span class='text-amber-200 font-medium'>{{n}} 人の保証人が逝去を確認します</span>。確認後、Postinity 管理者が登録されたメッセージを送信します。",
  pl_alert_title: "確認する前にお読みください",
  pl_alert_1: "<strong>このリンクは固有かつ個人的なものです</strong>：あなた専用ですので、共有しないでください。",
  pl_alert_2: "逝去の確認には<strong>3人の保証人全員の有効化が必須です</strong>。",
  pl_alert_3: "確認後、<strong>Postinity 管理者</strong>が登録されたメッセージを送信します。",
  pl_alert_4: "✅ 手続きは<strong>完全無料</strong>で<strong>厳重に機密</strong>です。",
  pl_status_rest: " / {{total}} 人の保証人が逝去を確認しました",
  pl_confirmed_saved: "あなたの確認は記録されています。",
  pl_all_confirmed: "すべての保証人が確認しました — Postinity の審査待ちです。",
  pl_waiting_others: "他の保証人の確認を待っています。",
  pl_confirm_btn: "逝去を確認する",
  ca_err_notfound: "この式典ファイルが見つかりません。",
  ca_unlocked: "ファイルのロックを解除しました 🎉",
  ca_badge: "私の式典ファイル",
  ca_songs_title: "式典の楽曲",
  ca_view_slideshow: "スライドショーを見る",
  ca_close: "閉じる",
  ca_not_available: "このファイルはまだ利用できません。",
  ca_create_msg: "式典ファイルにアクセスするには無料アカウントを作成してください。",
  ca_access_msg: "これらすべて（写真・動画・メッセージ）に {{price}} でアクセスできます。",
  ma_unlocked: "メッセージのロックを解除しました 🎉",
  ma_badge: "個人的なメッセージ",
  ma_default_title: "あなたへのメッセージ",
  ma_from: "差出人：",
  ma_someone: "大切な人",
  ma_for: "宛：",
  ma_download_btn: "メッセージをダウンロード",
  ma_read: "読む",
  ma_unlock_word: "ロック解除する",
  ma_create_msg: "このメッセージを{{action}}には無料アカウントを作成してください。",
  ma_read_free_btn: "このメッセージを読む（無料）",
  ma_unlock_msg: "この個人的なメッセージを {{price}} でロック解除。",
};
const zh = {
  ac_err_invalid: "此链接无效或已过期。",
  ac_err_load: "加载错误。",
  ac_pay_fail: "支付失败",
  ac_pay_canceled: "支付已取消。",
  ac_dl_fail: "下载失败",
  ac_video: "视频",
  ac_loading_video: "正在加载视频…",
  ac_photos_n: "{{count}} 张照片",
  ac_account_btn: "创建账户 / 登录",
  ac_tribute_to: "纪念 {{name}}",
  ac_unlock_price_btn: "以 {{price}} 解锁",
  pl_confirm1: "⚠️ 您即将确认此人的离世。\n\n此链接仅供您本人使用。只有当三位担保人全部确认后，确认才会生效。审核后，Postinity 管理员将发送已录入的留言。\n\n您要继续吗？",
  pl_confirm2: "您确定最终确认离世吗？（第二次确认）",
  pl_toast_ok: "您的确认已记录 🕯️",
  pl_toast_fail: "确认失败",
  pl_secure_link: "担保人安全链接",
  pl_intro: "{{name}}您被指定为本纪念的<span class='text-amber-200 font-medium'>担保人</span>。时机到来时，<span class='text-amber-200 font-medium'>{{n}} 位担保人确认离世</span>。审核后，Postinity 管理员将发送已录入的留言。",
  pl_alert_title: "确认前请阅读",
  pl_alert_1: "<strong>此链接是唯一且专属的</strong>：仅供您使用，请勿分享。",
  pl_alert_2: "确认离世<strong>必须激活三位担保人</strong>。",
  pl_alert_3: "审核后，<strong>Postinity 管理员</strong>将发送已录入的留言。",
  pl_alert_4: "✅ 整个流程<strong>完全免费</strong>且<strong>严格保密</strong>。",
  pl_status_rest: " / 共 {{total}} 位担保人已确认离世",
  pl_confirmed_saved: "您的确认已记录。",
  pl_all_confirmed: "所有担保人均已确认 — 等待 Postinity 审核。",
  pl_waiting_others: "等待其他担保人确认。",
  pl_confirm_btn: "确认离世",
  ca_err_notfound: "找不到此仪式档案。",
  ca_unlocked: "档案已解锁 🎉",
  ca_badge: "我的仪式档案",
  ca_songs_title: "仪式歌曲",
  ca_view_slideshow: "观看幻灯片",
  ca_close: "关闭",
  ca_not_available: "此档案暂不可用。",
  ca_create_msg: "创建免费账户即可访问仪式档案。",
  ca_access_msg: "以 {{price}} 访问全部内容（照片、视频、留言）。",
  ma_unlocked: "留言已解锁 🎉",
  ma_badge: "个人留言",
  ma_default_title: "给您的一条留言",
  ma_from: "来自",
  ma_someone: "一位亲友",
  ma_for: "致",
  ma_download_btn: "下载留言",
  ma_read: "阅读",
  ma_unlock_word: "解锁",
  ma_create_msg: "创建免费账户即可{{action}}此留言。",
  ma_read_free_btn: "阅读此留言（免费）",
  ma_unlock_msg: "以 {{price}} 解锁这条个人留言。",
};
export const postinity9 = { fr, en, es, de, it, pl, fil, ru, el, hi, ja, zh };
